import { render } from "./editClientPopup.vue?vue&type=template&id=d59f38c4&scoped=true"
import script from "./editClientPopup.vue?vue&type=script&lang=js"
export * from "./editClientPopup.vue?vue&type=script&lang=js"

import "./editClientPopup.vue?vue&type=style&index=0&id=d59f38c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d59f38c4"]])

export default __exports__